<template>
  <div>
    <section class="content">
      <div class="row">
        <!-- left column -->
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Offer Letter</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createOfferLetter">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Name of Reporting Manager <span class="red">*</span></label>
                  <input
                    v-model="form.reportingmanager"
                    type="text"
                    name="reportingmanager"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('reportingmanager'),
                    }"
                    placeholder="Reporting Manager"
                  />
                  <has-error :form="form" field="reportingmanager"></has-error>
                </div>
                <div class="form-group">
                  <label>Annual CTC <span class="red">*</span></label>
                  <input
                    v-model="form.annualctc"
                    type="text"
                    name="annualctc"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('annualctc'),
                    }"
                    placeholder="Enter Employee annual CTC"
                  />
                  <has-error :form="form" field="annualctc"></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Offer Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Experience Letter</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createExperienceletter">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Period Start Date <span class="red">*</span></label>
                    <input
                    v-model="form.periodStartDate"
                    type="date"
                    name="periodStartDate"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('periodStartDate'),
                    }"
                    placeholder="Period Start Date"
                    required
                    />
                    <has-error
                    :form="form"
                    field="periodStartDate"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Period End Date <span class="red">*</span></label>
                    <input
                    v-model="form.periodEndDate"
                    type="date"
                    name="periodEndDate"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('periodEndDate'),
                    }"
                    placeholder="Period End Date"
                    required
                    />
                    <has-error
                    :form="form"
                    field="periodEndDate"
                    ></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Experience Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Relieving Letter</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createRelievingletter">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Resignation Date <span class="red">*</span></label>
                    <input
                    v-model="form.resignationDate"
                    type="date"
                    name="resignationDate"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('resignationDate'),
                    }"
                    placeholder="Resignation Date"
                    required
                    />
                    <has-error
                    :form="form"
                    field="resignationDate"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Last Day of Employment <span class="red">*</span></label>
                    <input
                    v-model="form.lastDateOfEmployment"
                    type="date"
                    name="lastDateOfEmployment"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('lastDateOfEmployment'),
                    }"
                    placeholder="Last Day of Employment"
                    required
                    />
                    <has-error
                    :form="form"
                    field="lastDateOfEmployment"
                    ></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Relieving Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
        
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Confirmation Letter</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createConfirmationletter">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Probation Period Start Date <span class="red">*</span></label>
                    <input
                    v-model="form.probationPeriodStartDate"
                    type="date"
                    name="probationPeriodStartDate"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('probationPeriodStartDate'),
                    }"
                    placeholder="Period Start Date"
                    required
                    />
                    <has-error
                    :form="form"
                    field="probationPeriodStartDate"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Probation Period End Date <span class="red">*</span></label>
                    <input
                    v-model="form.probationPeriodEndDate"
                    type="date"
                    name="probationPeriodEndDate"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('probationPeriodEndDate'),
                    }"
                    placeholder="Period End Date"
                    required
                    />
                    <has-error
                    :form="form"
                    field="probationPeriodEndDate"
                    ></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Confirmation Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
       </div>
       <div class="row">
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Appointment Letter Permanent</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createAppointmentLetterPermanent">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Name of Reporting Manager <span class="red">*</span></label>
                  <input
                    v-model="form.reportingmanager"
                    type="text"
                    name="reportingmanager"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('reportingmanager'),
                    }"
                    placeholder="Reporting Manager"
                  />
                  <has-error :form="form" field="reportingmanager"></has-error>
                </div>
                 <div class="form-group">
                  <label>Contract Tenure <span class="red">*</span></label>
                  <input
                    v-model="form.contracttenure"
                    type="text"
                    name="contracttenure"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('contracttenure'),
                    }"
                    placeholder="Enter Employee Contract Tenure"
                  />
                  <has-error :form="form" field="contracttenure"></has-error>
                </div>
                <div class="form-group">
                  <label>Consultancy fees  <span class="red">*</span></label>
                  <input
                    v-model="form.consultancyfees"
                    type="text"
                    name="consultancyfees"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('consultancyfees'),
                    }"
                    placeholder="consultancy fees"
                  />
                  <has-error :form="form" field="consultancyfees"></has-error>
                </div>
                <div class="form-group">
                  <label>Monthly Gross Salary  <span class="red">*</span></label>
                  <input
                    v-model="form.monthlygrosssalary"
                    type="text"
                    name="monthlygrosssalary"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('monthlygrosssalary'),
                    }"
                    placeholder="Monthly Gross Salary"
                  />
                  <has-error :form="form" field="monthlygrosssalary"></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Appointment Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-3">
          <!-- general form elements -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Appointment Letter Contract</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->
            <form role="form" @submit.prevent="createAppointmentLetterContract">
              <div class="box-body">
                <div class="form-group">
                    <label>Branch <span class="red">*</span></label>
                    <select
                    v-model="form.branch_id"
                    name="branch_id"
                    class="form-control"
                    :class="{
                        'is-invalid': form.errors.has('branch_id'),
                    }"
                    @change="loadStaff"
                    >
                    <option
                        v-if="!form.branch_id"
                        selected
                        value=""
                    >
                        Select Company Branch
                    </option>
                    <option
                        :value="branch.id"
                        v-for="branch in branches"
                        :key="branch.id"
                    >
                        {{ branch.name }}
                    </option>
                    </select>
                    <has-error
                    :form="form"
                    field="branch_id"
                    ></has-error>
                </div>
                <div class="form-group">
                    <label>Employee ID <span class="red">*</span></label>
                    <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                    </v-select>
                    <has-error
                    :form="form"
                    field="agent_id"
                    ></has-error>
                </div>
                <div class="form-group">
                  <label>Name of Reporting Manager <span class="red">*</span></label>
                  <input
                    v-model="form.reportingmanager"
                    type="text"
                    name="reportingmanager"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('reportingmanager'),
                    }"
                    placeholder="Reporting Manager"
                  />
                  <has-error :form="form" field="reportingmanager"></has-error>
                </div>
                 <div class="form-group">
                  <label>Contract Tenure <span class="red">*</span></label>
                  <input
                    v-model="form.contracttenure"
                    type="text"
                    name="contracttenure"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('contracttenure'),
                    }"
                    placeholder="Enter Employee Contract Tenure"
                  />
                  <has-error :form="form" field="contracttenure"></has-error>
                </div>
                <div class="form-group">
                  <label>Consultancy fees  <span class="red">*</span></label>
                  <input
                    v-model="form.consultancyfees"
                    type="text"
                    name="consultancyfees"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('consultancyfees'),
                    }"
                    placeholder="consultancy fees"
                  />
                  <has-error :form="form" field="consultancyfees"></has-error>
                </div>
                <div class="form-group">
                  <label>Travel Fare Limit  <span class="red">*</span></label>
                  <input
                    v-model="form.travelfare"
                    type="text"
                    name="travelfare"
                    class="form-control"
                    :class="{
                    'is-invalid': form.errors.has('travelfare'),
                    }"
                    placeholder="Travel Fare Limit"
                  />
                  <has-error :form="form" field="travelfare"></has-error>
                </div>
              </div>
              <!-- /.box-body -->

              <div class="box-footer">
                <button type="submit" class="btn btn-primary">Create Appointment Letter</button>
              </div>
            </form>
          </div>
          <!-- /.box -->
        </div>
        <!--/.col (left) -->
        <offerletter :seeRecord="seeRecord" :reportingmanager="form.reportingmanager" :annualctc="form.annualctc" :getCompanyRecord="getCompanyRecord" :logo="logo"></offerletter>
        <appointmentlettercontract :seeRecord="seeRecord" :travelfare="form.travelfare" :reportingmanager="form.reportingmanager" :consultancyfees="form.consultancyfees" :contracttenure="form.contracttenure" :getCompanyRecord="getCompanyRecord" :logo="logo"></appointmentlettercontract>
        <appointmentletterpermanent :seeRecord="seeRecord" :monthlygrosssalary="form.monthlygrosssalary" :reportingmanager="form.reportingmanager" :consultancyfees="form.consultancyfees" :contracttenure="form.contracttenure" :getCompanyRecord="getCompanyRecord" :logo="logo"></appointmentletterpermanent>
        <confirmationletter :seeRecord="seeRecord" :probationPeriodStartDate="form.probationPeriodStartDate" :probationPeriodEndDate="form.probationPeriodEndDate" :getCompanyRecord="getCompanyRecord" :logo="logo"></confirmationletter>
        <experienceletter :seeRecord="seeRecord" :periodStartDate="form.periodStartDate" :periodEndDate="form.periodEndDate" :getCompanyRecord="getCompanyRecord" :logo="logo"></experienceletter>
        <relievingletter :seeRecord="seeRecord" :resignationDate="form.resignationDate" :lastDateOfEmployment="form.lastDateOfEmployment" :getCompanyRecord="getCompanyRecord" :logo="logo"></relievingletter>
      </div>
      <!-- /.row -->
    </section>
  </div>
</template>
<script>
import GetBranch from '../../mixins/BranchRecords'
import offerletter from '../components/OfferLetter.vue'
import appointmentlettercontract from '../components/AppointmentLetterContract.vue'
import appointmentletterpermanent from '../components/AppointmentLetterPermanent.vue'
import confirmationletter from '../components/ConfirmationLetter.vue'
import experienceletter from '../components/ExperienceLetter.vue'
import relievingletter from '../components/RelievingLetter.vue'
export default {
  name: 'PrintEmployeeLetter',
  mixins: [GetBranch],
  components: {
    offerletter,
    appointmentlettercontract,
    appointmentletterpermanent,
    confirmationletter,
    experienceletter,
    relievingletter
  },
  data () {
    return {
      form: new Form({
        id: '',
        branch_id: '',
        employee_id: '',
        role_id: '',
        salary: '',
        reportingmanager: '',
        annualctc: '',
        contracttenure: '',
        consultancyfees: '',
        travelfare: '',
        monthlygrosssalary: '',
        probationPeriodStartDate: '',
        periodStartDate: '',
        probationPeriodEndDate: '',
        periodEndDate: '',
        resignationDate: '',
        lastDateOfEmployment: '',
        alias: '',
        bank_id: '',
        mobile: '',
        phone: '',
        email: '',
        transactionDate: '',
        fatherName: '',
        address: '',
        city: '',
        state_id: '',
        nationality: '',
        pin: '',
        joiningDate: new Date().toISOString().slice(0, 10),
        photo: '',
        lastExperience: '',
        accountHolderName: '',
        accountNumber: '',
        pan: '',
        panStatus: 'false',
        aadhar: '',
        aadharStatus: 'false',
        bank_branch: '',
        ifsc: '',
        basicSalary: '',
        fixedDeduction: '',
        fixedAllowance: '',
        incomeTax: '',
        numberOfMonthForFixedDeduction: '',
        numberOfMonthIncomeTax: '',
        reason_id: '',
        otp: '',
        status: ''
        // errors: {errors: null}
        // errors:{ 'errors': { 'name': [ 'The name field is required' ], 'mobile': [ 'The mobile field is required' ], 'branch_id': [ 'The branch id field is required' ], 'bank_id': [ 'The bank id field is required.' ], 'state_id': [ 'The state id must be a number.' ], 'pin': [ 'The pin must be a number.', 'The pin must be 6 digits.' ], 'bank_id': [ 'The bank id must be a number.' ] } }
      }),
      staffs: [],
      staff: {},
      branches: {},
      seeRecord: {},
      getCompanyRecord: {},
      logo: ''
    }
  },
  methods: {
    createOfferLetter () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewOfferLetter').modal({backdrop: 'static', keyboard: false})
    },
    createAppointmentLetterContract () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewAppointmentLetterContract').modal({backdrop: 'static', keyboard: false})
    },
    createAppointmentLetterPermanent () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewAppointmentLetterPermanent').modal({backdrop: 'static', keyboard: false})
    },
    createConfirmationletter () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewConfirmationletter').modal({backdrop: 'static', keyboard: false})
    },
    createExperienceletter () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewExperienceletter').modal({backdrop: 'static', keyboard: false})
    },
    createRelievingletter () {
      this.seeRecord = this.staff
      this.loadCompanyProfile()
      $('#viewRelievingletter').modal({backdrop: 'static', keyboard: false})
    },
    getEmployeeDetails () {
      this.form.employee_id = this.staff.user_id
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getBranch () {
      this.$axios
        .get('branch?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.staff = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.getBranch()
  }
}
</script>



// WEBPACK FOOTER //
// PrintEmployeeLetter.vue?6431eb7d